import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import router from "@/router";
import { RouterProvider } from "react-router-dom";
import { supportedCultures } from "./util";
import packageJson from "../package.json";
import i18nInit from "./i18n-init";
import "@/assets/icons.css";
import Cookies from "js-cookie";

const detectSupportedLanguage = () => {
    const browserLanguagesTwoLetter = navigator.languages.map((x) => x.split("-", 1)[0]);
    const supportedCulturesMap = supportedCultures.reduce((acc, cultureName) => {
        const twoLetter = cultureName.split("-", 1)[0];
        acc.set(twoLetter, cultureName);
        return acc;
    }, new Map<string, string>());

    for (let i = 0; i < browserLanguagesTwoLetter.length; i++) {
        const search = browserLanguagesTwoLetter[i];
        const found = supportedCulturesMap.get(search);
        if (found) {
            return found;
        }
    }
    return supportedCultures[0];
};

async function main() {
    // Get language for i18n
    let cultureName = localStorage.getItem("Culture");
    if (!cultureName) {
        // by defult lang should be he-IL
        // cultureName = detectSupportedLanguage();
        cultureName = "he-IL";
        localStorage.setItem("Culture", cultureName);
        Cookies.set(".AspNetCore.Culture", `c=${cultureName}|uic=${cultureName}`, { expires: 365 });
    }
    // else if (!supportedCultures.find((x) => x === cultureName)) {
    //     cultureName = detectSupportedLanguage();
    //     localStorage.setItem("Culture", cultureName);
    // }
    // i18n Init
    await i18nInit(cultureName, packageJson.version);
    // React Start App
    const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
    root.render(<RouterProvider router={router} />);

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}

main();
